import { Bounce, ToastContainer } from 'react-toastify';

const ToastProvider = () => {
  return <>
    <ToastContainer
      position='top-center'
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss={false}
      draggable={false}
      pauseOnHover={false}
      theme='light'
      limit={3}
      transition={Bounce}
      style={{ width: 'max-content' }}
      closeButton={false}
      className='text-center justify-content-center align-middle'
    />
  </>;
};

export default ToastProvider;
